'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _webComponents = require('@vezeeta/web-components');

var _Helpers = require('@vezeeta/enterprise-utils/lib/Helpers');

var _vacations = require('../actions/vacations');

var _vacations2 = require('../types/vacations');

var _vacations3 = _interopRequireDefault(_vacations2);

var _language = require('../types/language');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var todayDate = new Date();
var dateAfterSixDays = (0, _Helpers.getDateAfterGivenDays)(6);
var defaultState = {
  vacations: _webComponents.renderer.loading(),
  vacationsList: [],
  selected: {
    branches: [],
    rooms: [],
    doctors: [],
    startDate: (0, _Helpers.getFormattedDate)(todayDate),
    endDate: (0, _Helpers.getFormattedDate)(dateAfterSixDays)
  },
  addVacation: {
    data: '',
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' }
  },
  deleteVacation: {
    data: '',
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' }
  },
  reservationsInRange: {
    reservationsInRange: null,
    data: _language.language === 'en' ? 'Choose vacation range' : 'اختر تاريخ بدء وانتهاء العطلة',
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' }
  },
  isCalendarEmpty: false,
  isFilterEmpty: false,
  snackBar: { show: false, message: '' },
  addVacationModal: { show: false },
  deleteVacationModal: {
    show: false,
    vacationDetails: {}
  }
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var _ref = arguments[1];

  var type = _ref.type,
      action = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _vacations.VACATIONS.LOAD:
      return Object.assign({}, state, {
        vacations: _webComponents.renderer.loading()
      });

    case _vacations.VACATIONS.LOAD_DONE:
      {
        if (action.vacations.length > 0) {
          return Object.assign({}, state, {
            vacations: _webComponents.renderer.success(action.vacations),
            vacationsList: action.vacations
          });
        }
        return Object.assign({}, state, {
          vacations: _webComponents.renderer.empty(_vacations3.default.NO_VACATIONS),
          vacationsList: action.vacations
        });
      }

    case _vacations.VACATIONS.LOAD_FAIL:
      {
        return Object.assign({}, state, {
          vacations: _webComponents.renderer.failure(_language.language === 'en' ? 'An Error has happened' : 'لقد حدث خطاء ما')
        });
      }

    case _vacations.VACATIONS.FILTERED.SET_SELECTED_BRANCH:
      {
        return Object.assign({}, state, {
          selected: Object.assign({}, state.selected, { branches: action.branches })
        });
      }

    case _vacations.VACATIONS.FILTERED.SET_SELECTED_ROOMS:
      {
        if (action.rooms.length > 0) {
          return Object.assign({}, state, {
            isFilterEmpty: false,
            selected: Object.assign({}, state.selected, { rooms: action.rooms })
          });
        }
        return Object.assign({}, state, {
          isFilterEmpty: true,
          vacations: _webComponents.renderer.empty(_vacations3.default.EMPTY_FILTER),
          selected: Object.assign({}, state.selected, { rooms: action.rooms })
        });
      }

    case _vacations.VACATIONS.FILTERED.SET_SELECTED_DOCTORS:
      {
        var selectedDoctors = action.doctors;
        if (selectedDoctors.length > 0) {
          return Object.assign({}, state, {
            isFilterEmpty: false,
            selected: Object.assign({}, state.selected, { doctors: selectedDoctors })
          });
        }

        return Object.assign({}, state, {
          isFilterEmpty: true,
          vacations: _webComponents.renderer.empty(action.hasDoctors ? _vacations3.default.EMPTY_FILTER : _vacations3.default.NO_USERS),
          selected: Object.assign({}, state.selected, { doctors: selectedDoctors })
        });
      }

    case _vacations.VACATIONS.FILTERED.SET_DATES:
      {
        if (!action.data.startDate || !action.data.endDate) {
          return Object.assign({}, state, {
            isCalendarEmpty: true,
            vacations: _webComponents.renderer.empty(_vacations3.default.EMPTY_CALENDAR),
            selected: Object.assign({}, state.selected, {
              startDate: action.data.startDate,
              endDate: action.data.endDate
            })
          });
        }

        var doctors = state.selected.doctors;
        var vacations = state.vacations;

        if (doctors.length === 0) {
          vacations = _webComponents.renderer.empty(_vacations3.default.NO_USERS);
        }

        return Object.assign({}, state, {
          isCalendarEmpty: false,
          vacations: vacations,
          selected: Object.assign({}, state.selected, {
            startDate: action.data.startDate,
            endDate: action.data.endDate
          })
        });
      }

    case _vacations.VACATIONS.ADD:
      {
        var addVacation = action.vacation ? action.vacation : [];
        return Object.assign({}, state, {
          addVacation: {
            data: addVacation,
            isFetching: true,
            isSuccess: false,
            isFail: {
              isError: false
            }
          }
        });
      }

    case _vacations.VACATIONS.ADD_DONE:
      {
        if (state.vacations && action.vacation) {
          var newState = _extends({}, state);
          var justAddedArray = state.vacationsList;
          action.vacation.forEach(function (vacation) {
            var vacationObject = vacation;
            vacationObject.Model[0].justAdded = true;
            vacationObject.DoctorName = action.doctors.find(function (doctor) {
              return vacationObject.AccountKey === doctor.AccountKey;
            }).DoctorName;
            vacationObject.RoomName = action.rooms.find(function (room) {
              return vacationObject.RoomKey === room.RoomKey;
            }).RoomName;
            justAddedArray.unshift(vacationObject);
          });

          return Object.assign({}, newState, {
            vacations: _webComponents.renderer.success(justAddedArray),
            vacationsList: justAddedArray,
            addVacation: {
              isFetching: false,
              isSuccess: true,
              isFail: {
                isError: false
              }
            },
            reservationsInRange: {
              reservationsInRange: null,
              data: _language.language === 'en' ? 'Choose vacation range' : 'اختر تاريخ بدء وانتهاء العطلة',
              isFetching: false,
              isSuccess: false,
              isFail: { isError: false, message: '' }
            },
            addVacationModal: { show: false },
            snackBar: {
              show: true,
              message: _language.language === 'en' ? 'Vacation Added successfully' : 'تم إضافة العطلة بنجاح'
            }
          });
        }
        return Object.assign({}, state, {
          addVacation: {
            isFetching: false,
            isSuccess: true,
            isFail: {
              isError: false
            }
          },
          reservationsInRange: {
            reservationsInRange: null,
            data: _language.language === 'en' ? 'Choose vacation range' : 'اختر تاريخ بدء وانتهاء العطلة',
            isFetching: false,
            isSuccess: false,
            isFail: { isError: false, message: '' }
          },
          addVacationModal: { show: false },
          snackBar: {
            show: !state.snackBar.show,
            message: _language.language === 'en' ? 'Vacation Added successfully' : 'تم إضافة العطلة بنجاح'
          }
        });
      }
    case _vacations.VACATIONS.ADD_FAIL:
      {
        return Object.assign({}, state, {
          addVacation: {
            isFetching: false,
            isSuccess: false,
            isFail: {
              isError: true,
              message: action.err ? action.err : action.res
            }
          },
          addVacationModal: {
            show: false
          },
          reservationsInRange: {
            reservationsInRange: null,
            data: _language.language === 'en' ? 'Choose vacation range' : 'اختر تاريخ بدء وانتهاء العطلة',
            isFetching: false,
            isSuccess: false,
            isFail: { isError: false, message: '' }
          },
          snackBar: {
            show: !state.snackBar.show,
            message: _language.language === 'en' ? 'An Error has happened' : 'لقد حدث خطاء ما'
          }
        });
      }
    case _vacations.VACATIONS.DELETE:
      {
        return Object.assign({}, state, {
          deleteVacation: {
            data: '',
            isFetching: true,
            isSuccess: false,
            isFail: { isError: false, message: '' }
          }
        });
      }
    case _vacations.VACATIONS.DELETE_DONE:
      {
        if (state.vacations && action.vacation) {
          var _newState = _extends({}, state);
          _newState.vacationsList = state.vacationsList;
          action.vacation.doctors.forEach(function (doctor) {
            _newState.vacationsList.forEach(function (vacation, index) {
              var newStateVacation = vacation;
              var checkAccount = newStateVacation.AccountKey === doctor.AccountKey;
              var checkRoom = newStateVacation.RoomKey === doctor.RoomKey;
              var checkDates = newStateVacation.Model && newStateVacation.Model[0].From === action.vacation.startDate && newStateVacation.Model[0].To === action.vacation.endDate;
              if (checkAccount && checkRoom && checkDates) {
                newStateVacation.Model[0].isDeleted = true;
                _newState.vacationsList[index] = newStateVacation;
              }
            });
          });
          return Object.assign({}, _newState, {
            vacations: _webComponents.renderer.success(_newState.vacationsList),
            vacationsList: _newState.vacationsList,
            deleteVacation: {
              data: '',
              isFetching: false,
              isSuccess: true,
              isFail: { isError: false, message: '' }
            },
            snackBar: {
              show: true,
              message: _language.language === 'en' ? 'Vacation deleted successfully' : 'تم حذف العطلة بنجاح'
            },
            deleteVacationModal: { show: false, vacationDetails: {} }
          });
        }
        return Object.assign({}, state, {
          deleteVacation: {
            data: '',
            isFetching: false,
            isSuccess: true,
            isFail: { isError: false, message: '' }
          },
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Vacation deleted successfully' : 'تم حذف العطلة بنجاح'
          },
          deleteVacationModal: { show: false, vacationDetails: {} }
        });
      }
    case _vacations.VACATIONS.DELETE_FAIL:
      {
        return Object.assign({}, state, {
          deleteVacation: {
            isFetching: false,
            isSuccess: false,
            isFail: {
              isError: true,
              message: action.err ? action.err : action.res
            }
          }
        });
      }
    case _vacations.VACATIONS.MODAL.TOGGLE_DELETE:
      {
        return Object.assign({}, state, {
          deleteVacationModal: { show: action.showModal, vacationDetails: {} }
        });
      }
    case _vacations.VACATIONS.MODAL.TOGGLE_ADD:
      {
        return Object.assign({}, state, {
          addVacationModal: { show: action.showModal }
        });
      }
    case _vacations.VACATIONS.SET_DELETE_MESSAGE:
      {
        return Object.assign({}, state, {
          deleteVacationModal: {
            show: state.deleteVacationModal.show,
            vacationDetails: action.message
          }
        });
      }
    case _vacations.VACATIONS.RESERVATIONS_IN_RANGE.LOAD:
      {
        return Object.assign({}, state, {
          reservationsInRange: {
            reservationsInRange: null,
            data: 0,
            isFetching: true,
            isSuccess: false,
            isFail: {
              isError: false
            }
          }
        });
      }
    case _vacations.VACATIONS.RESERVATIONS_IN_RANGE.LOAD_DONE:
      {
        var message = void 0;
        if (action.reservationsInRange === 0) {
          message = _language.language === 'en' ? 'There are no appointments in this range' : 'لا يوجد حجوزات في الفترة المحددة';
        } else {
          var enMessage = action.reservationsInRange + ' appointment' + (action.reservationsInRange > 1 ? 's' : '') + ' will be canceled';
          var cancelWord = void 0;
          if (action.reservationsInRange > 2 && action.reservationsInRange < 11) {
            cancelWord = 'حجوزات';
          } else if (action.reservationsInRange === 2) {
            cancelWord = 'حجزين';
          } else {
            cancelWord = 'حجز';
          }
          var reservNumber = _language.language === 'en' ? action.reservationsInRange : (0, _Helpers.toIndiaDigits)(action.reservationsInRange.toString());

          var arMessage = '\u0633\u064A\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 ' + (action.reservationsInRange !== 2 ? reservNumber : '') + ' ' + cancelWord;

          message = _language.language === 'en' ? enMessage : arMessage;
        }

        return Object.assign({}, state, {
          reservationsInRange: {
            reservationsInRange: action.reservationsInRange,
            data: message,
            isFetching: false,
            isSuccess: true,
            isFail: {
              isError: false
            }
          }
        });
      }
    case _vacations.VACATIONS.RESERVATIONS_IN_RANGE.LOAD_FAIL:
      {
        return Object.assign({}, state, {
          reservationsInRange: {
            isFetching: false,
            isSuccess: false,
            isFail: {
              isError: true,
              message: action.err ? action.err : action.res
            }
          }
        });
      }
    case _vacations.VACATIONS.RESERVATIONS_IN_RANGE.RESET:
      {
        return _extends({}, state, {
          reservationsInRange: {
            data: _language.language === 'en' ? 'Choose vacation range' : 'اختر تاريخ بدء وانتهاء العطلة',
            isSuccess: false,
            isFail: {
              isError: false,
              message: ''
            }
          }
        });
      }
    case _vacations.VACATIONS.SET_SNACK_BAR_AS_HIDDEN:
      {
        return Object.assign({}, state, {
          snackBar: { show: false }
        });
      }
    default:
      return state;
  }
};

module.exports = exports['default'];